import Axios from "axios";

class BaseService {
    protected axios!: Axios.AxiosInstance;
    constructor(baseURL: string) {
        this.axios = Axios.create({
            baseURL,
            headers: {},
        });

        this.axios.interceptors.request.use(
            (config) => this.requestInterceptor(config),
            (error) => {
                this.requestInterceptor(error, true);
            },
        );
    }

    protected requestInterceptor(config: any, error?: boolean): any {
        return {
            ...config,
        };
    }
}

export { BaseService };
